import { IAppState } from '../../redux';

export function selectActiveServiceIndex(state: IAppState): number | undefined {
  const {
    publishTerms: { selectedServiceId, serviceIds },
  } = state;

  if (!selectedServiceId) {
    return undefined;
  }

  return serviceIds.indexOf(selectedServiceId);
}
